import React from 'react';
import { useI18n } from '../i18n';
import { usePrefs } from './prefs';

/** `.bx-app` root of every page, carrying theme, direction, language and density like the designs. */
export function AppFrame({ children, className, style }: { children: React.ReactNode; className?: string; style?: React.CSSProperties }) {
  const { theme, density } = usePrefs();
  const { code, dir } = useI18n();
  return (
    <div
      className={'bx-app' + (className ? ' ' + className : '')}
      style={style}
      data-theme={theme}
      dir={dir}
      lang={code}
      data-density={density}
    >
      {children}
    </div>
  );
}
